import { defineMessages } from "react-intl";

import { preImmunisationQueries } from "lib/build/dashboards/ktx/queries";
import { PreviousOtherOrganTransplantationType } from "lib/build/forms/ktx/basic-registration-data/clinical-data/pre-immunisation/previousOtherOrganTransplantation";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useEventsByQuery } from "src/features/events";
import { compareByTimestamp } from "src/modules/shared/dashboard";

const valueMessages = defineMessages({
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_KIDNEY]: {
		id: "ktx.header.prevTransKidney",
		defaultMessage: "Vese"
	},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LIVER]: {
		id: "ktx.header.prevTransLiver",
		defaultMessage: "Máj"
	},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_HEART]: {
		id: "ktx.header.prevTransHeart",
		defaultMessage: "Szív"
	},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LUNG]: {
		id: "ktx.header.prevTransLung",
		defaultMessage: "Tüdő"
	},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_PANCREAS]: {
		id: "ktx.header.prevTransPancreas",
		defaultMessage: "Pancreas"
	},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_BONE_MARROW]:
		{
			id: "ktx.header.prevTransBoneMarrow",
			defaultMessage: "Csontvelő"
		},
	[PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_OTHER]: {
		id: "ktx.header.prevTransOther",
		defaultMessage: "Egyéb"
	}
});

export function usePreviousOtherOrganTransplantation(): string {
	const events = useEventsByQuery<string>(
		preImmunisationQueries.previousOtherOrganTransplantation
	);
	const formatMessage = useFormatMessageMap();
	const values = events
		.filter(event => event.value in valueMessages)
		.sort(compareByTimestamp)
		.map(event => event.value)
		.filter(value => value in valueMessages)
		.map(value => formatMessage(valueMessages, value));
	const uniqueValues = [...new Set(values)];
	return uniqueValues.length === 0 ? "-" : uniqueValues.join(", ");
}
